export default __webpack_public_path__ + "static/700-703-d486cfe586e22240761febe9da48ba5d.jpg";